module.exports = __webpack_public_path__ + "img/Picture3.b9b7f3fb.png";